export const MAPEAMENTO_TITULO_SERVICO: Record<string, string> = {
    'Cível Presencial': 'Audiência Cível',
    'Cível Virtual': 'Audiência Cível',
    'Trabalhista Presencial': 'Audiência Trabalhista',
    'Trabalhista Virtual': 'Audiência Trabalhista',
    'Penal Presencial': 'Audiência Penal',
    'Penal Virtual': 'Audiência Penal',
    'Outros Presencial': 'Outras Audiências',
    'Outros Virtual': 'Outras Audiências',
    'Outros': 'Outro serviço'
};

export const mapearTituloBancoParaExibicao = (tituloBanco: string | undefined): string | undefined => {
    if (!tituloBanco) return undefined;
    return MAPEAMENTO_TITULO_SERVICO[tituloBanco] || tituloBanco;
};
